import DataTableV2 from "components/commons/data-table/data-table-v2";
import React from "react";

const AccountList = ({ table, ...props }) => {
  return <DataTableV2 {...table} {...props} />;
}

export default AccountList;